import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles(
  (theme: Theme) => ({
    main: {
      //width: '30%',
      marginTop: theme.spacing(8),
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: 20,
      fontWeight: 500,
      color: 'black',
      letterSpacing: 0.15,
      margin: `${theme.spacing()}px ${theme.spacing(1.5)}px 0`,
      marginBottom: theme.spacing(2),
    },
    licenseInfoTitle: {
      width: `calc(100% - ${theme.spacing(3)}px)`,
      marginLeft: theme.spacing(1.5),
      marginTop: theme.spacing(0.5),
      //height: 39,
      fontSize: 16,
      //textTransform: 'uppercase',
      //lineHeight: '32px',
      //letterSpacing: 1,
    },
    subTitle: {
      margin: '24px 12px -4px',
      fontSize: 14,
      textTransform: 'uppercase',
      lineHeight: '32px',
      letterSpacing: 1,
    },
    paper: {
      width: '25%',
      //marginTop: theme.spacing(1),
      padding: theme.spacing(1.5),
    },
    formControl: {
      width: `calc(100% - ${theme.spacing(3)}px)`,
      margin: theme.spacing(1.5),
      height: 39,
    },
    link: {
      color: '#007DFF',
      fontSize: 14,
      letterSpacing: 0.15,
      marginRight: theme.spacing(1.5),
    },
    button: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(0.5),
      height: 39,
      width: '100%',
      textTransform: 'none',
      letterSpacing: 0.15,
      fontSize: 14,
    },
    container: {
      margin: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    footnote: {
      fontSize: 12,
      letterSpacing: 0.4,
      opacity: 0.54,
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(2),
    },
    errorText: {
      color: theme.palette.error.main,
    },
    divider: {
      margin: `0 -${theme.spacing(1.5)}px ${theme.spacing(2.5)}px`,
    },
  }),
  {
    index: 1,
  }
);
